module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm2"
    }
  }, [_c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRAISE FOR")]), _vm._v(" KATE GRENVILLE")]), _vm._v(" "), _c('p', {
    staticClass: "head2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("THE LIEUTENANT")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘It glows with life: imaginative in its recreations, respectful of what cannot be imagined, and thoughtful in its interrogation of the past.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Age")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘Dry, exact and lush all at once, this book is Grenville at her best.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Australian")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘A supremely good novel.’ DIANA ATHILL")]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘Grenville’s craft is, as always, astounding, deftly melding subject and metaphor, story and image…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lieutenant ")]), _vm._v("succeeds beautifully.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Canberra Times")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘Elegantly calibrated prose…a lovely, watchful stillness: a sort of astronomy of the human heart.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sunday Telegraph")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘Grenville writes with a poet’s sense of rhythm and imagery.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guardian")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘In lucid prose and perfectly measured strides, Grenville lays down her riveting tale. A novel aglow with empathy, its author’s capacious visions still deliver an elemental thrill.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘A profoundly uplifting novel.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independent")])]), _vm._v(" "), _c('p', {
    staticClass: "cent"
  }, [_vm._v("‘This novel is a triumph. Read it at once.’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-929b9190","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Praise_For_Kate_Grenville1.vue
// module id = 66
// module chunks = 0